export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14309.aed36ca1.jpg";